import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveLatestEvents } from "../../../redux/slice/latest-events-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import Card from "../../../widgets/cards";

const PopularEvents = () => {
  const { popularEventsData, loading, error } = useSelector(
    (state: RootState) => state.latestEvents
  );

  const dispatch = useAppDispatch();
  const numberOfEvents = 1;

  useEffect(() => {
    dispatch(retrieveLatestEvents(numberOfEvents));
  }, [dispatch]);

  var articles = popularEventsData.map((item, index) => {
    return {
      date: "",
      author: "",
      icon: "",
      category: "Popular Events",
      title: item.eventName,
      description: item.eventName,
      img: item.sideImage,
      alt: item.eventName,
      showHomePage: true,
      articleURL: `/events/${item.nodeName}`
    };
  });

  var latestArticles = [
    {
      title: "Popular Events",
      link: "/events",
      article: articles,
    },
  ];

  return <Card cardData={latestArticles} />;
};

export default PopularEvents;
